import { getDashboardContextValue } from "./dashboardContext";

const DASHBOARD_SCOPED_PREFIXES = [
  "/access-manager",
  "/attendee/verify",
  "/checkin-checkout-confirmation",
  "/communication",
  "/dashboard",
  "/exhibitor",
  "/exhibitor-settings",
  "/exhibitor-summary",
  "/exhibitors",
  "/hall-details",
  "/hall-layouts",
  "/hall-listing",
  "/layout",
  "/manage",
  "/private",
  "/registration",
  "/rsvp",
  "/scan",
  "/ticket/custom",
  "/ticketScanner",
  "/zone-check-in",
];

export const getDashboardSlug = () => {
  if (typeof window === "undefined") return "";
  return getDashboardContextValue("eventSlug") || "";
};

export const dashboardPath = (path = "", slug = getDashboardSlug()) => {
  const splitIndex = path.search(/[?#]/);
  const pathOnly = splitIndex === -1 ? path : path.slice(0, splitIndex);
  const queryHash = splitIndex === -1 ? "" : path.slice(splitIndex);
  const cleanPath = pathOnly.replace(/^\/+/, "");
  const suffix = cleanPath ? `/${cleanPath}` : "";
  return `${slug ? `/dashboard/${slug}${suffix}` : `/dashboard${suffix}`}${queryHash}`;
};

export const isDashboardScopedPath = (path = "") => {
  const splitIndex = path.search(/[?#]/);
  const pathOnly = splitIndex === -1 ? path : path.slice(0, splitIndex);
  const normalizedPath = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
  return DASHBOARD_SCOPED_PREFIXES.some(
    (prefix) => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`),
  );
};

export const toDashboardPath = (path = "", slug = getDashboardSlug()) => {
  const rawPath = String(path || "").trim();
  if (!rawPath) return dashboardPath("", slug);
  if (/^(?:[a-z][a-z0-9+.-]*:|\/\/|#)/i.test(rawPath)) return rawPath;

  const splitIndex = rawPath.search(/[?#]/);
  const pathOnly = splitIndex === -1 ? rawPath : rawPath.slice(0, splitIndex);
  const queryHash = splitIndex === -1 ? "" : rawPath.slice(splitIndex);
  const parts = pathOnly.split("/").filter(Boolean);
  let normalizedPath;

  if (parts[0] === "dashboard") {
    if (parts.length === 1 || parts[1] === slug) {
      normalizedPath = parts.slice(2).join("/");
    } else {
      normalizedPath = parts.slice(1).join("/");
    }
  } else {
    normalizedPath = pathOnly.replace(/^\/+/, "");
  }

  if (queryHash) normalizedPath = `${normalizedPath}${queryHash}`;
  return dashboardPath(normalizedPath, slug);
};

export const stripDashboardSlug = (pathname) => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "dashboard" || parts.length < 2) return pathname;
  if (parts.length < 3) return "/dashboard";
  return `/${parts.slice(2).join("/")}`;
};
